import { useEffect, useState } from "react";
import Slider from "react-slick";
import { getBirthdays } from "../Service/Api";
import LazyLoad from "react-lazyload";

const StaffBirthday = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const birthdayData = await getBirthdays();

        const filterbirthday = birthdayData.filter(
          (item) => item.school === "NEKPUR" && item.category === "Student",
        );
        setData(filterbirthday);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const emptyArray = [
    {
      name: "Student Name",
      class: "Class",
      date: "DD MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/cake.jpg",
    },
    {
      name: "Student Name",
      class: "Class",
      date: "DD MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/cake.jpg",
    },
    {
      name: "Student Name",
      class: "Class",
      date: "DD MM",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/cake.jpg",
    },
    // Other entries...
  ];

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <Slider {...settings}>
        {data && data.length > 0
          ? data.map((item, index) => {
              const date = new Date();
              const day = date.getDate();
              const month = date.getMonth();
              const mymonth = monthNames[month];

              return (
                <div className="item" key={index}>
                  <div className="topperdiv birthdaybg">
                    <div className="toppertaj">
                      <LazyLoad>
                        <img
                          src={
                            item.attachments && item.attachments[0]
                              ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                              : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/cake.jpg"
                          }
                          className="img-fluid"
                        />
                      </LazyLoad>
                    </div>
                    <div className="topperdesc">
                      <p className="name">{item.name} </p>
                      <p className="per">
                        {day} {mymonth}
                      </p>
                      <p>{item.class}</p>
                    </div>
                  </div>
                </div>
              );
            })
          : emptyArray.map((item, index) => (
              <div className="item" key={index}>
                <div className="topperdiv birthdaybg">
                  <div className="toppertaj">
                    <LazyLoad>
                      {" "}
                      <img
                        src={item.attachments}
                        className="img-fluid"
                        alt="Default"
                      />
                    </LazyLoad>
                  </div>
                  <div className="topperdesc">
                    <p className="name">{item.name} </p>
                    <p className="per">{item.date}</p>
                    <p>{item.class}</p>
                  </div>
                </div>
              </div>
            ))}
      </Slider>
    </>
  );
};

export default StaffBirthday;
